export default __webpack_public_path__ + "static/media/HN_Resume.b6b47b76.png";